
















































import { Component, Prop, Vue } from 'vue-property-decorator'
import Button from '@/app/ui/components/Button/index.vue';
import IconSync from '@/app/ui/assets/icon_sync.vue'
import Skeleton from '@/app/ui/components/Skeleton/index.vue';

@Component({
  components: {
    Button,
    IconSync,
    Skeleton
  }
})
class PickupCorporateHeader extends Vue {
  @Prop({ type: String, required: true }) public latestSyncDisplay!: string;
  @Prop({ type: String, required: true }) public manualAssignRoute!: string;
  @Prop({ type: Boolean, required: true }) public isSyncLoading!: boolean;
  @Prop({ type: Boolean, required: true }) public isExportLoading!: boolean;
  @Prop({ type: String, required: true }) public transportType!: string;

}

export default PickupCorporateHeader;
